var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "healthicons:yes-outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9705 21 21 16.9705 21 12C21 7.0295 16.9705 3 12 3C7.0295 3 3 7.0295 3 12C3 16.9705 7.0295 21 12 21ZM12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z",
    fill: "#1AAB5B",
    stroke: "#1AAB5B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#1AAB5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.335 8.12999C17.4334 8.21885 17.4924 8.34314 17.4992 8.47553C17.5059 8.60792 17.4598 8.73757 17.371 8.83599L10.693 16.2165L6.65501 12.362C6.56434 12.2693 6.51321 12.1451 6.5124 12.0154C6.51159 11.8858 6.56117 11.7609 6.65068 11.6671C6.74019 11.5733 6.86262 11.518 6.99216 11.5127C7.1217 11.5075 7.24822 11.5527 7.34501 11.639L10.64 14.784L16.6295 8.16549C16.6736 8.11678 16.7268 8.07723 16.7862 8.04911C16.8456 8.02099 16.9099 8.00484 16.9755 8.00159C17.0411 7.99834 17.1067 8.00805 17.1686 8.03017C17.2304 8.05228 17.2873 8.08637 17.336 8.13049",
    fill: "#EFF5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.335 8.12999C17.4334 8.21885 17.4924 8.34314 17.4992 8.47553C17.5059 8.60792 17.4598 8.73757 17.371 8.83599L10.693 16.2165L6.65501 12.362C6.56434 12.2693 6.51321 12.1451 6.5124 12.0154C6.51159 11.8858 6.56117 11.7609 6.65068 11.6671C6.74019 11.5733 6.86262 11.518 6.99216 11.5127C7.1217 11.5075 7.24822 11.5527 7.34501 11.639L10.64 14.784L16.6295 8.16549C16.6736 8.11678 16.7268 8.07723 16.7862 8.04911C16.8456 8.02099 16.9099 8.00484 16.9755 8.00159C17.0411 7.99834 17.1067 8.00805 17.1686 8.03017C17.2304 8.05228 17.2873 8.08637 17.336 8.13049",
    stroke: "#EFF5F3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.63ccc6001caec18c1fb9f73bf4848ec1.svg";
export { ForwardRef as ReactComponent };